<template>
  <home-page />
</template>

<script>
import HomePage from "./index.vue";
export default {
  name: 'App',
  components: {
    HomePage
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 20px;
  box-sizing: border-box;
}
h1,h2,label,p {
  color: darkmagenta;
  font-size: larger;
}
</style>
